export default "__VITE_ASSET__DTxUWGrC__"